<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
<!--      <div class="table-page-search-wrapper">-->
<!--        <a-form layout="inline">-->
<!--          <a-row :gutter="48">-->
<!--            <a-col :md="8" :sm="24">-->
<!--              <a-form-item label="內容" prop="content">-->
<!--                <a-input v-model="queryParam.content" placeholder="請輸入內容" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="!advanced && 8 || 24" :sm="24">-->
<!--              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">-->
<!--                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>-->
<!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->
<!--              </span>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </a-form>-->
<!--      </div>-->

      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <!-- <a-divider type="vertical"/> -->
          <a @click="handleDelete(record)">
            <a-icon type="delete" />刪除
          </a>
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-drawer>
</template>

<script>
import { pageHotRecord,listHotRecord, delHotRecord } from '@/api/platform/hotRecord'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ShowHotRecord',
  components: {

  },
  mixins: [tableMixin],
  data () {
    return {
      formTitle: '熱門記錄列表',
      open: false,
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        byUserId: null,
        resourceType: null,
        resourceId: null,
        commentId: null,
        replyId: null,
        userId: null,
        content: null,
        replyCommentUserId: null,
        replyNum: null,
        likeNum: null,
        type: null,
        isDisable: null,
        atUserIds: null,
        atUserNames: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '作品類型',
        //   dataIndex: 'resourceType',
        //   ellipsis: true,
        //   align: 'center',
        //   customRender: function (value, record) {
        //     if (value == 1) {
        //       return "視頻"
        //     }
        //     if (value == 2) {
        //       return "賽事"
        //     }
        //     if (value == 3) {
        //       return "PK"
        //     }
        //   }
        // },
        {
          title: '套餐Id',
          dataIndex: 'gearid',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '購買的播放量',
          dataIndex: 'paynum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用戶暱稱',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '刷手號',
          dataIndex: 'userNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '原有播放量',
          dataIndex: 'primarynum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '購買時間',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '操作',
        //   dataIndex: 'operation',
        //   width: '18%',
        //   scopedSlots: { customRender: 'operation' },
        //   align: 'center'
        // }
      ]
    }
  },
  filters: {
  },
  created () {
    // this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按鈕
    cancel () {
      this.open = false
      this.reset()
    },
    /** 查詢作品-評價回覆列表 */
    getList (id) {
      console.log(id)
      this.formType = 1
      this.open = true
      this.loading = true
      this.queryParam.videoId = id
      pageHotRecord(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList(this.queryParam.videoId)
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        byUserId: undefined,
        resourceType: undefined,
        videoId: this.queryParam.videoId,
        commentId: undefined,
        replyId: undefined,
        userId: undefined,
        content: undefined,
        replyCommentUserId: undefined,
        replyNum: undefined,
        likeNum: undefined,
        type: undefined,
        isDisable: undefined,
        atUserIds: undefined,
        atUserNames: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList(this.queryParam.videoId)
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList(this.queryParam.videoId)
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUserComment(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList(this.queryParam.videoId)
              that.$message.success(
                '刪除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/user-comment/export', {
            ...that.queryParam
          }, `作品-評價回覆_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
